module.exports = __webpack_public_path__ + "img/swiper3_m.a417e91f.png";